import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AutoCompleteSearchComponent } from 'src/app/private/modules/components/auto-complete-search/auto-complete-search.component';
import { ContactsService } from 'src/app/private/services/contacts.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { capitalizeName } from 'src/app/utils/name-format.util';
import { CountryISO } from 'ngx-intl-tel-input';
import { assignIntlPhone, phoneControlValue, regionForDialCode } from 'src/app/utils/phone-country.util';
import { LEAD_SOURCE_OPTIONS } from 'src/app/utils/lead-field-options.util';


@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.scss']
})
export class AddContactComponent {
  @ViewChild(AutoCompleteSearchComponent) childComponent!: AutoCompleteSearchComponent;
  @Input() formAction: string = 'Create';
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() editData: any;
  @Output() reload: EventEmitter<any> = new EventEmitter();
  btnLoading = false;
  @Input() users: any;
  @Input() allLeadFields: any;
  account: any;
  today: string = new Date().toISOString().split('T')[0]; // Current date in YYYY-MM-DD format

  leadSources: string[] = [...LEAD_SOURCE_OPTIONS];

  isSubmitted: boolean = false;

  isValidEmail(email: string, form: any, key: any): boolean {
    const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      form.controls[key].setErrors({ invalid: true });
      return false;
    } else {
      form.controls[key].setErrors(null);
      return true;
    }
  }

  contact : any = {
    contact_owner: '',
    first_name: '',
    last_name: '',
    fax: '',
    title: '',
    department: '',
    client_id: '',
    center_id: '',
    email: '',
    secondary_email: '',
    skype_id: '',
    description: '',
    phone: '',
    other_phone: '',
    mobile: '',
    country_code: '',
    address: {
      street: '',
      city: '',
      state: '',
      postal_code: '',
      country: ''
    },
    lead_source: '',
    account_id: '',
    dob: '',
    fields: {}
  };



  constructor(
    private toast: ToastrService,
    private api: ContactsService,
    private localStorage: LocalStorageService,
    private tracker: TrackingService
  ) { }


  ngOnInit(): void {
    
    if (this.formAction === 'Update') {
      this.contact = this.editData;
      this.account = this.editData?.account;
      this.contact.fields = this.editData?.fields || {};
      this.contact.first_name = capitalizeName(String(this.contact.first_name || ''));
      this.contact.last_name = capitalizeName(String(this.contact.last_name || ''));
    }
  }



 

  saveContact(isValid: any) {
    this.isSubmitted = true;
    if (isValid) {

      // if((this.childComponent.selectedId === undefined ||
      //   this.childComponent.selectedId === null ||
      //   this.childComponent.selectedId === '') && this.formAction === 'Create') {
      //     this.toast.error('Please select account');
      //     return;
      // }

      console.log('Form submitted:', this.contact);

      this.btnLoading = true;

      this.contact.first_name = capitalizeName(String(this.contact.first_name || ''));
      this.contact.last_name = capitalizeName(String(this.contact.last_name || ''));

      let  payload = {
        ...this.contact,
        client_id: this.localStorage.getClientId(),
        center_id: this.localStorage.getCenterId(),
        account_id: this.childComponent?.selectedId ?? this.contact.account_id,
      }

      console.log("Payload to be sent:", payload);


      if (this.formAction === 'Create') {
        this.api.createContact(payload).subscribe({
          next: (res: any) => {
            this.toast.success('Contact added successfully');
            this.btnLoading = false;
            const desc = `Contact created with name: ${this.contact.first_name} ${this.contact.last_name} with contact id: ${res.contact_id}`;
          this.tracker.track("Create", "Contact", desc);
            this.close.emit();
            this.reload.emit();
            
          },
          error: (e: any) => {
            console.error(e);
            this.toast.error('Error while adding contact');
            this.btnLoading = false;
          }
        });
      } else {
        this.api.updateContact(payload).subscribe({
          next: (res: any) => {
            this.toast.success('Contact updated successfully');
            this.btnLoading = false;
              // ✅ Tracking contact update
          const desc = `Contact updated with name: ${this.contact.first_name} ${this.contact.last_name} and contact id: ${this.contact.contact_id}`;
          this.tracker.track("Update", "Contact", desc);
            this.close.emit();
            this.reload.emit();
           
          },
          error: (e: any) => {
            console.error(e);
            this.toast.error('Error while updating contact');
            this.btnLoading = false;
          }
        });
      }

      // Implement your form submission logic here
    } else {
      this.toast.error('Please fill all required fields correctly');
      console.log('Form is invalid');
    }
  }

  get mobileCountryIso(): CountryISO {
    return regionForDialCode(this.contact?.['country_code']);
  }

  get mobileNumber() {
    return phoneControlValue(this.contact['country_code'], this.contact['mobile']);
  }

  set mobileNumber(value: any) {
    assignIntlPhone(this.contact, 'mobile', value);
  }
 
  



  closeModal() {
    this.close.emit();
  }

  formatNameField(field: 'first_name' | 'last_name'): void {
    const value = this.contact[field];
    if (typeof value !== 'string') {
      return;
    }
    this.contact[field] = capitalizeName(value);
  }

  formatFieldLabel(label: string): string {
    const trimmed = String(label || '').trim();
    if (!trimmed) {
      return '';
    }
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
  }

  getDobDateModel(): Date | null {
    return this.parseStoredDate(this.contact.dob);
  }

  setDobDate(value: Date | null): void {
    this.contact.dob = this.formatStoredDate(value);
  }

  getDobMaxDate(): Date {
    return new Date();
  }

  getContactFieldDateModel(fieldName: string): Date | null {
    return this.parseStoredDate(this.contact.fields?.[fieldName]);
  }

  setContactFieldDate(fieldName: string, value: Date | null): void {
    this.contact.fields[fieldName] = this.formatStoredDate(value);
  }

  private parseStoredDate(value: unknown): Date | null {
    if (!value) {
      return null;
    }
    const date = new Date(String(value));
    return Number.isNaN(date.getTime()) ? null : date;
  }

  private formatStoredDate(value: Date | null): string {
    if (!value || Number.isNaN(value.getTime())) {
      return '';
    }
    const yyyy = value.getFullYear();
    const mm = String(value.getMonth() + 1).padStart(2, '0');
    const dd = String(value.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
}